export default "__VITE_ASSET__BsAIr9pe__"